export enum ELIGIBILITY_STATUS {
  ADDRESS_FORM = 'ADDRESS_FORM',
  ELIGIBLE_FOR_FRESH = 'ELIGIBLE_FOR_FRESH',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NOTIFICATION_FORM = 'NOTIFICATION_FORM',
}

export enum checkAddressSource {
  FRESH_ADD_TO_CART = 'FRESH_ADD_TO_CART',
  ULTRA_FRESH_ADD_TO_CART = 'ULTRA_FRESH_ADD_TO_CART',
  DEFAULT = 'DEFAULT',
}

export const productEligibilityDocument: {
  [key: string]: [customType: string, documentUid: string];
} = {
  [checkAddressSource.FRESH_ADD_TO_CART]: [
    'producteligibilitymodal',
    'fresh-product-eligibility-modal',
  ],
  [checkAddressSource.ULTRA_FRESH_ADD_TO_CART]: [
    'producteligibilitymodal',
    'ultra-fresh-product-eligibility-modal',
  ],
  [checkAddressSource.DEFAULT]: [
    'producteligibilitymodal',
    'default-product-eligibility-modal',
  ],
};

export enum Perishability {
  DRY = 'DRY',
  FRESH = 'FRESH',
  ULTRA_FRESH = 'ULTRA_FRESH',
}
